import SectionHead from "./SectionHead";
import { isOpenable } from "../actions";
import { SECTION_COPY } from "../copy";

/** Deterministic pastel per expert, so an avatar keeps its colour between loads. */
const PALETTE = [
  "linear-gradient(160deg, #d4ffcc, #7ee08f)",
  "linear-gradient(160deg, #bfcbfc, #5ea8f0)",
  "linear-gradient(160deg, #ffd9a0, #f0a64e)",
  "linear-gradient(160deg, #e9c6f5, #b475d8)",
];

const initials = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

/**
 * EXPERT_DIALOGUES (Figma 9154:8266) — a horizontal rail of avatar cards, an
 * entitlement surface that is absent today (no expert content is seeded).
 *
 * Each item is a UniversalDialogueCard plus `author` (the expert's name) and
 * `topic` (§7 E6). `title` is the Dialogue's own title, not the expert. There
 * is no `avatar_url`, so the avatar is the author's initials; a card without
 * an `author` falls back to its title so it is never blank.
 */
function ExpertDialoguesSection({ section, onOpenDialogue }) {
  const items = (section?.items || []).filter(isOpenable);
  if (items.length === 0) return null;

  const c = SECTION_COPY.EXPERT_DIALOGUES;

  return (
    <section className="ex-section">
      <SectionHead title={c.title} subtitle={c.subtitle} />

      <div className="ex-rail ex-rail--experts">
        {items.map((item, i) => {
          const name = item.author || item.title || "";
          return (
            <button
              key={item.dialogue_id || i}
              type="button"
              className="ex-expert"
              onClick={() => onOpenDialogue?.(item)}
              title={item.author ? item.title : undefined}
            >
              <span
                className="ex-expert__avatar"
                style={{ background: PALETTE[i % PALETTE.length] }}
              >
                {initials(name)}
              </span>
              <span className="ex-expert__name">{name}</span>
              {item.topic && <span className="ex-expert__specialty">{item.topic}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default ExpertDialoguesSection;
